<template>
  <button
    v-if="!authenticated"
    data-testid="signInDesktopBtn"
    class="font-bold text-base sign-in-nav-button"
    @click="openModal"
  >
    {{ SIGN_IN }}
  </button>
  <NavigationDesktopAccountMenu v-else :sub-menu="ACCOUNT_MENU" />
</template>
<script setup lang="ts">
import { SIGN_IN } from '~/constants/services/constants'
import { ACCOUNT_MENU } from '~/constants/main-menu'
import { useModalStore } from '~/stores/modal'
import useAuthStore from '~/stores/auth'

const authStore = useAuthStore()
const modalStore = useModalStore()

const authenticated = computed(() => authStore.authenticated)

const openModal = () => {
  modalStore.open('signIn')
  modalStore.setPriceSpotlightLoginVariantActive(false)
}
</script>
